/*** IMPORTS FROM imports-loader ***/
import hydrator from "@gjensidige/views-api/src/runtime/hydrator";
import Component from ".";

/* global hydrator, Component */

// create a map of what we have hydrated, share it on window
window.__HYDRATED__ = window.__HYDRATED__ || {};

// get the current script executing
const partSrc = window.document?.currentScript?.getAttribute('src');

// filter the ones that need to be hydrated (data-nodeid contains the id for the props -> only hydration on node id's)
const parts = Array.from(
  document.querySelectorAll('script[src="' + partSrc + '"]')
).filter((part) => part.getAttribute('data-nodeid'));

// if this selection of parts contains elements that needs to be hydrated, add an eventListener
if (parts.length && window.addEventListener) {
  window.addEventListener('load', function () {
    parts.forEach((part) => {
      // make sure we only hydrate our components once
      const NODE_ID = part.getAttribute('data-nodeid');
      if (!window.__HYDRATED__[NODE_ID]) {
        window.__HYDRATED__[NODE_ID] = true;
        hydrator(Component, NODE_ID);
      }
    });
  });
}


import '@gjensidige/nci-core-typography/lib-css/index.css';
import '@gjensidige/nci-core-grid/lib-css/index.css';

import React from 'react';
import { MessageBus } from '@podium/browser';
import classNames from 'classnames';
import PropTypes from 'prop-types/prop-types';
import superagent from 'superagent';
import utils from '@gjensidige/core-utilities-css';
import { Col } from '@gjensidige/nci-core-grid/lib-css/col';
import { Container } from '@gjensidige/nci-core-grid/lib-css/container';
import { Row } from '@gjensidige/nci-core-grid/lib-css/row';
import { KeyboardArrowRight } from '@gjensidige/nci-core-icons/lib/keyboard-arrow-right';
import { Link } from '@gjensidige/nci-core-typography/lib-css/link';
import { Text } from '@gjensidige/nci-core-typography/lib-css/text';
import { Title } from '@gjensidige/nci-core-typography/lib-css/title';

import CallMe from './call-me';
import { FooterDataProps as Props, OptionalFooterApiUrl } from './types';

import linkStyles from '@gjensidige/core-typography/less/link/link.module.less';
import styles from '../less/footer.module.less';
const messageBus = new MessageBus();

export const Footer = ({
  footerData,
  callMeApiUrl,
  baseUrl
}: OptionalFooterApiUrl) => {
  const {
    phone,
    email,
    facebook,
    cookiePreferences,
    twitter,
    instagram,
    linkedin,
    copyright,
    links,
    segment,
    callMeButtonText,
    callMePageUrl
  } = footerData as Props;
  return (
    <footer
      className={styles.overrides}
      style={{ position: 'relative', zIndex: 2 }}
    >
      <Container>
        <Row>
          <Col className={styles.horizontalLine}></Col>
        </Row>
      </Container>
      {segment && (
        <div className={styles.sitemapWrapper}>
          <Container className={classNames(utils['py-3'], utils['py-lg-4'])}>
            <Row>
              <Col className={classNames(utils['align-content-between'])}>
                <Row>
                  {segment?.sections?.map((section, index) => (
                    <Col
                      xxs="12"
                      lg="4"
                      key={`index_${index}_${section.label.title}`}
                      className={classNames(
                        { [utils['mt-3']]: index > 0 },
                        utils['mt-lg-0']
                      )}
                    >
                      <Title
                        tag="h2"
                        id={`footerId-${index}`}
                        size="h5"
                        className={classNames(
                          utils['mb-2'],
                          utils['mb-lg-4'],
                          styles.segmentTitle
                        )}
                      >
                        {section.label.title}
                      </Title>
                      <nav aria-labelledby={`footerId-${index}`}>
                        {section.menuItems?.length > 0 &&
                          section.menuItems.map((menuItem, index) => (
                            <div
                              key={`index_${index}_${menuItem.title}`}
                              className={classNames(styles.sectionItem)}
                            >
                              <Link href={menuItem.url}>{menuItem.title}</Link>
                            </div>
                          ))}
                      </nav>
                    </Col>
                  ))}
                </Row>
              </Col>

              <Col
                xxs="12"
                lg="3"
                className={classNames(
                  utils['mt-4'],
                  utils['mt-lg-0'],
                  utils['d-flex'],
                  utils['flex-column'],
                  utils['align-items-lg-end']
                )}
              >
                {segment?.ctas?.map((cta, index) => (
                  <div
                    key={`index_${index}_${cta.title}`}
                    className={styles.ctaElement}
                  >
                    <a href={cta.url} className={styles.ctaElementLink}>
                      <div>
                        <Text>{cta.title}</Text>
                      </div>
                      <div className={utils['d-flex']}>
                        <KeyboardArrowRight size={20} />
                      </div>
                    </a>
                  </div>
                ))}
              </Col>
            </Row>
          </Container>
        </div>
      )}
      <div className={styles.footerWrapper}>
        <Container
          className={classNames(utils['pt-3'], utils['pb-9'], utils['pt-lg-4'])}
        >
          <Row>
            <Col className={classNames(utils['align-content-between'])}>
              <Row>
                <Col xxs="12" lg="4">
                  <Media media={phone} type="phone" />
                  <CallMe
                    apiUrl={callMeApiUrl}
                    baseUrl={baseUrl}
                    text={callMeButtonText}
                    target={callMePageUrl}
                  />
                  <Media media={email} type="email" />
                </Col>
                <Col xxs="12" lg="4">
                  <Media media={instagram} type="instagram" />
                  <Media media={facebook} type="facebook" />
                  <Media media={twitter} type="twitter" />
                  <Media media={linkedin} type="linkedin" />
                </Col>
                {links?.length > 0 && (
                  <Col
                    xxs="12"
                    lg="4"
                    className={classNames(utils['mt-2'], utils['mt-lg-0'])}
                  >
                    {cookiePreferences?.label && (
                      <div className={utils['mb-2']}>
                        <button
                          className={classNames(
                            styles.changeCookiePreferences,
                            linkStyles.a
                          )}
                          onClick={() =>
                            messageBus.publish(
                              'cookie',
                              'triggerChangePreferences'
                            )
                          }
                        >
                          {cookiePreferences.label}
                        </button>
                      </div>
                    )}
                    {links.map((link, index) => (
                      <div
                        key={`index_${index}_${link.linkText}`}
                        className={classNames(utils['mb-2'])}
                      >
                        <Link href={link.linkTarget} className={styles.link}>
                          {link.linkText ? link.linkText : link.linkTarget}
                        </Link>
                      </div>
                    ))}
                  </Col>
                )}
              </Row>
            </Col>

            {copyright && (
              <Col
                xxs="12"
                lg="3"
                className={classNames(utils['mt-2'], utils['mt-lg-0'])}
              >
                <Text
                  size="small"
                  className={classNames(
                    utils['d-flex'],
                    utils['justify-content-lg-end']
                  )}
                >
                  {copyright}
                </Text>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  baseUrl: PropTypes.string,
  footerApiUrl: PropTypes.string,
  footerData: PropTypes.object,
  callMeApiUrl: PropTypes.string
};

Footer.CSR = true;

Footer.getServerSideProps = async function ({ footerApiUrl }) {
  if (!footerApiUrl) {
    console.error(
      `missing required footerApiUrl prop set by FOOTER_API_URL env var`
    );
  }

  try {
    const res = await superagent
      .post(`${footerApiUrl}`)
      .accept('application/json')
      .retry()
      .send();

    return {
      footerData: res.body
    };
  } catch (e) {
    console.log('could not fetch footer data because of: ', e);
  }
};

export default Footer;

const Media = ({ media, type }) => {
  if (media) {
    if (type === 'phone' || type === 'email') {
      const href = `${type === 'phone' ? 'tel:' : 'mailto:'}${media.url}`;
      return (
        <div className={classNames(utils['mb-2'], utils['mb-lg-3'])}>
          <Link href={href} className={styles[`${type}`]}>
            {media.label ? media.label : media.url}
          </Link>
        </div>
      );
    }
    const href = media.linkTarget;
    return (
      <div className={classNames(utils['mb-2'], utils['mb-lg-3'])}>
        <Link href={href} className={styles[`${type}`]}>
          {media.linkText ? media.linkText : media.linkTarget}
        </Link>
      </div>
    );
  }
  return <></>;
};
